document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(() => {
        // 該当のDOM要素を取得
        const compareAtPriceElement = document.querySelector(".product-info__block-item[data-block-type='price'] .text-subdued.line-through");
        if (compareAtPriceElement) {
            // テキストの長さに基づいたピクセル幅を計算
            const textWidth = getTextWidth(compareAtPriceElement.textContent, getComputedStyle(compareAtPriceElement));
            
            // CSSカスタムプロパティを設定
            compareAtPriceElement.style.setProperty("--dynamic-width", `${textWidth}px`);
            
            // MutationObserverを停止
            observer.disconnect();
        }
    });

    // bodyを監視
    observer.observe(document.body, { childList: true, subtree: true });
});

/**
 * 指定された文字列の幅を計算
 * @param {string} text 計算対象の文字列
 * @param {CSSStyleDeclaration} style 要素のスタイル情報
 * @returns {number} テキストのピクセル幅
 */
function getTextWidth(text, style) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = `${style.fontSize} ${style.fontFamily}`;
    const textWidth = context.measureText(text).width;

    // スケールファクターを調整（必要に応じて）
    const scaleFactor = 0.5;
    return textWidth * scaleFactor;
}
